export default {
  ALIGNERS: 'ALIGNERS',
  BRACES: 'BRACES',
} as const
